import allPaths from "../Config/paths"
import dentalProcedure1 from "../secondAssets/Images/dentalProcedure1.png"
import dentalProcedure2 from "../secondAssets/Images/dentalProcedure2.png"
import dentalProcedure3 from "../secondAssets/Images/dentalProcedure3.png"
import dentalProcedure4 from "../secondAssets/Images/dentalProcedure4.png"
import dentalProcedure5 from "../secondAssets/Images/dentalProcedure5.png"
import dentalProcedure6 from "../secondAssets/Images/dentalProcedure6.png"
import service_img_1 from "../secondAssets/Images/service-1.jpeg"
import service_img_2 from "../secondAssets/Images/service-2.jpeg"
import service_img_3 from "../secondAssets/Images/service-3.jpeg"
import service_img_4 from "../secondAssets/Images/service-4.jpeg"
import service_img_5 from "../secondAssets/Images/service-5.jpeg"
import service_img_6 from "../secondAssets/Images/service-6.jpeg"
import procedure_img_1 from "../secondAssets/Images/procedureImg1.jpeg"
import procedure_img_2 from "../secondAssets/Images/procedureImg2.jpeg"
import procedure_img_3 from "../secondAssets/Images/procedureImg3.jpg"
import procedure_img_4 from "../secondAssets/Images/procedureImg4.jpg"
import procedure_img_5 from "../secondAssets/Images/procedureImg5.jpg"
import procedure_img_6 from "../secondAssets/Images/procedureImg6.jpeg"
import doctor_img_1 from "../secondAssets/Images/doctorImg1.jpeg"
import doctor_img_2 from "../secondAssets/Images/doctorImg2.jpeg"
import doctor_img_3 from "../secondAssets/Images/doctorImg3.jpeg"
import doctor_img_4 from "../secondAssets/Images/doctorImg1.jpeg"
import location_img_1 from "../secondAssets/Images/locationImg1.jpeg"
import location_img_2 from "../secondAssets/Images/locationImg2.jpeg"
import location_img_3 from "../secondAssets/Images/locationImg3.jpeg"
import serviceSliderImg1 from "../secondAssets/Images/serviceSliderImg1.png"
import serviceSliderImg2 from "../secondAssets/Images/serviceSliderImg2.png"
import serviceSliderImg3 from "../secondAssets/Images/serviceSliderImg3.png"
import serviceSliderImg4 from "../secondAssets/Images/serviceSliderImg4.png"
import serviceSliderImg5 from "../secondAssets/Images/serviceSliderImg5.png"
import serviceSliderImg6 from "../secondAssets/Images/serviceSliderImg6.png"
import serviceSliderImg7 from "../secondAssets/Images/serviceSliderImg7.png"
import aboutImg1 from "../secondAssets/Images/about1.jpeg"
import aboutImg2 from "../secondAssets/Images/about2.jpeg"
import aboutImg3 from "../secondAssets/Images/about3.jpeg"
import ModernTitle1 from "../secondAssets/Images/modernTitle1.jpeg"
import ModernTitle2 from "../secondAssets/Images/modernTitle2.jpeg"
import ModernTitle3 from "../secondAssets/Images/modernTitle3.jpeg"
import ModernTitle4 from "../secondAssets/Images/modernTitle4.jpeg"
import ModernTitle5 from "../secondAssets/Images/modernTitle5.jpeg"
import ModernTitle6 from "../secondAssets/Images/modernTitle6.jpeg"
import ModernTitle7 from "../secondAssets/Images/modernTitle7.jpeg"
import ModernTitle8 from "../secondAssets/Images/modernTitle8.jpeg"
import ModernTitle9 from "../secondAssets/Images/modernTitle9.jpeg"
import ModernTitle10 from "../secondAssets/Images/modernTitle10.jpeg"
import ModernTitle11 from "../secondAssets/Images/modernTitle11.jpeg"
import ModernTitle12 from "../secondAssets/Images/modernTitle12.jpeg"
import aboutSolutionTeethImg from "../secondAssets/Images/aboutSolutionTeethImg.png"
import aboutSolutionSwimImg from "../secondAssets/Images/aboutSolutionSwimImg.png"
import shopImg1 from "../secondAssets/Images/shopImg1.jpeg"
import shopImg2 from "../secondAssets/Images/shopImg2.jpeg"
import shopImg3 from "../secondAssets/Images/shopImg3.jpeg"
import shopImg4 from "../secondAssets/Images/shopImg4.jpeg"
import shopImg5 from "../secondAssets/Images/shopImg5.jpeg"
import shopImg6 from "../secondAssets/Images/shopImg6.jpeg"
import shopImg7 from "../secondAssets/Images/shopImg7.jpeg"
import shopImg8 from "../secondAssets/Images/shopImg8.jpeg"
import shopImg9 from "../secondAssets/Images/shopImg9.jpeg"
import shopImg10 from "../secondAssets/Images/shopImg10.jpeg"
import shopImg11 from "../secondAssets/Images/shopImg11.jpeg"
import shopImg12 from "../secondAssets/Images/shopImg12.jpeg"
import shopImg13 from "../secondAssets/Images/shopImg13.jpeg"
import shopImg14 from "../secondAssets/Images/shopImg14.jpeg"
import shopImg15 from "../secondAssets/Images/shopImg15.jpeg"
import shopImg16 from "../secondAssets/Images/shopImg16.jpeg"
import procedureDayOneimg1 from "../secondAssets/Images/procedureDayOneimg1.jpg"
import procedureDayOneimg2 from "../secondAssets/Images/procedureDayOneimg2.jpg"
import procedureDayOneimg3 from "../secondAssets/Images/procedureDayOneimg3.jpg"
import procedureDayTwoImg2 from "../secondAssets/Images/procedureDayTwoImg1.jpg"
import procedureDayTwoImg1 from "../secondAssets/Images/procedureDayTwoImg.jpg"
import { FaUserDoctor, FaHeartPulse, FaHospital, FaHeadset } from "react-icons/fa6";
import { FaQuestion, FaFemale } from "react-icons/fa";
import { GiFirstAidKit } from "react-icons/gi";
import { Rate } from 'antd';
const menuItems = [
    {
        menuName: 'Home',
        menuGLName: 'Heim',
        menuALName: 'بيت',
        menuRoute: allPaths?.SECONDHOME,
    },
    {
        menuName: 'About',
        menuGLName: 'Um',
        menuALName: 'عن',
        menuRoute: allPaths?.ABOUT,
        submenu: [
            { name: 'About Page 2', glName: 'Über Seite 2', alName: 'حول الصفحة 2', route: allPaths?.SECONDABOUT },
            { name: 'Before After', glName: 'Vorher Nachher', alName: 'قبل بعد', route: allPaths?.BEFOREAFTER },
            { name: 'Dental Store', glName: 'Dentalgeschäft', alName: 'متجر الأسنان', route: allPaths?.DENTALSTORE },
        ],
    },
    {
        menuName: 'Services',
        menuGLName: 'Dienstleistungen',
        menuALName: 'خدمات',
        menuRoute: allPaths?.SECONDSERVICE,
        submenu: [
            { name: 'Procedure', glName: 'Verfahren', alName: 'إجراء', route: allPaths?.PROCEDURE },
        ],
    },
    {
        menuName: 'Portfolio',
        menuGLName: 'Portfolio',
        menuALName: 'مَلَفّ',
        menuRoute: allPaths?.PORTFOLIO,
    },
    {
        menuName: 'Appointment',
        menuGLName: 'Termin',
        menuALName: 'ميعاد',
        menuRoute: allPaths?.APPOINTMENT,
    },
    {
        menuName: 'Content Form',
        menuGLName: 'Inhaltsformular',
        menuALName: 'نموذج المحتوى',
        menuRoute: allPaths?.SECONDDESIGNCONTENTFORM,
    },
    {
        menuName: 'Service Form',
        menuGLName: 'Serviceformular',
        menuALName: 'نموذج الخدمة',
        menuRoute: allPaths?.SECONDDESIGNSERVICEFORM,
    },
    {
        menuName: 'Doctor Form',
        menuGLName: 'Arztformular',
        menuALName: 'استمارة دكتور',
        menuRoute: allPaths?.SECONDDESIGNDOCTORFORM,
    },
];

const homeDentalProcedure = [
    {
        img: dentalProcedure1,
        name: 'Oral Examinations',
        glName: 'Mündliche Untersuchungen',
        alName: 'الفحوصات الشفهية',
    },
    {
        img: dentalProcedure2,
        name: 'Braces & Bonding',
        glName: 'Zahnspangen & Verbindung',
        alName: 'الأقواس والتصاق',
    },
    {
        img: dentalProcedure3,
        name: 'Dentures & Repairs',
        glName: 'Prothesen & Reparaturen',
        alName: 'التركيبات والإصلاحات',
    },
    {
        img: dentalProcedure4,
        name: 'Root Canals',
        glName: 'Wurzelkanäle',
        alName: 'قنوات الجذر',
    },
    {
        img: dentalProcedure5,
        name: 'Crown & Caps',
        glName: 'Krone & Kappen',
        alName: 'التاج والكبس',
    },
    {
        img: dentalProcedure6,
        name: 'Extractions & Gum Surgery',
        glName: 'Extraktionen & Zahnfleischoperationen',
        alName: 'الاستخراجات وجراحة اللثة',
    },
];
const serviceSliderImg = [
    {
        img: serviceSliderImg1,
    },
    {
        img: serviceSliderImg2,
    },
    {
        img: serviceSliderImg3,
    },
    {
        img: serviceSliderImg4,
    },
    {
        img: serviceSliderImg5,
    },
    {
        img: serviceSliderImg6,
    },
    {
        img: serviceSliderImg7,
    },

];
const serviceData = [
    {
        imageUrl: service_img_1,
        heading: 'Dental Filling for Cavities',
        text: "Impediment from, poison of life, just. There is no such thing as a soft-footed soccer ball. Complete keyboard. Tomorrow's protein.c",
        glHeading: 'Zahnfüllung für Karies', 
        alHeading: 'تعبئة الأسنان للتسوس',
        glText: 'Hindernis vom Gift des Lebens, einfach. Es gibt so etwas wie einen weichen Fußball nicht. Komplette Tastatur. Proteinpulver von morgen.', 
        alText: 'عائق من سم الحياة، ببساطة. لا يوجد شيء اسمه كرة قدم ناعمة. لوحة مفاتيح كاملة. بروتين الغد.',
    },
    {
        imageUrl: service_img_2,
        heading: 'Regular Dental Cleaning',
        text: "Impediment from, poison of life, just. There is no such thing as a soft-footed soccer ball. Complete keyboard. Tomorrow's protein.c",
        glHeading: 'Regelmäßige Zahnreinigung', 
        alHeading: 'تنظيف الأسنان العادي',
        glText: 'Hindernis vom Gift des Lebens, einfach. Es gibt so etwas wie einen weichen Fußball nicht. Komplette Tastatur. Proteinpulver von morgen.', 
        alText: 'عائق من سم الحياة، ببساطة. لا يوجد شيء اسمه كرة قدم ناعمة. لوحة مفاتيح كاملة. بروتين الغد.',
    },
    {
        imageUrl: service_img_3,
        heading: 'Tingling Sensation-pulpitis',
        text: "Impediment from, poison of life, just. There is no such thing as a soft-footed soccer ball. Complete keyboard. Tomorrow's protein.c",
        glHeading: 'Kribbelndes Gefühl - Pulpitis', 
        alHeading: 'إحساس الوخز - التهاب اللب',
        glText: 'Hindernis vom Gift des Lebens, einfach. Es gibt so etwas wie einen weichen Fußball nicht. Komplette Tastatur. Proteinpulver von morgen.', 
        alText: 'عائق من سم الحياة، ببساطة. لا يوجد شيء اسمه كرة قدم ناعمة. لوحة مفاتيح كاملة. بروتين الغد.',
    },
    {
        imageUrl: service_img_4,
        heading: 'Relief - After The Dental Exam!',
        text: "Impediment from, poison of life, just. There is no such thing as a soft-footed soccer ball. Complete keyboard. Tomorrow's protein.c",
        glHeading: 'Erleichterung - Nach der Zahnuntersuchung!', 
        alHeading: 'الإغاثة - بعد الفحص الطبي للأسنان!',
        glText: 'Hindernis vom Gift des Lebens, einfach. Es gibt so etwas wie einen weichen Fußball nicht. Komplette Tastatur. Proteinpulver von morgen.', 
        alText: 'عائق من سم الحياة، ببساطة. لا يوجد شيء اسمه كرة قدم ناعمة. لوحة مفاتيح كاملة. بروتين الغد.',
    },
    {
        imageUrl: service_img_5,
        heading: 'The Invisalign Alternative for Braces',
        text: "Impediment from, poison of life, just. There is no such thing as a soft-footed soccer ball. Complete keyboard. Tomorrow's protein.c",
        glHeading: 'Die Invisalign-Alternative für Zahnspangen', 
        alHeading: 'البدائل لتقويم الأسنان إنفيزالين',
        glText: 'Hindernis vom Gift des Lebens, einfach. Es gibt so etwas wie einen weichen Fußball nicht. Komplette Tastatur. Proteinpulver von morgen.', 
        alText: 'عائق من سم الحياة، ببساطة. لا يوجد شيء اسمه كرة قدم ناعمة. لوحة مفاتيح كاملة. بروتين الغد.',
    },
    {
        imageUrl: service_img_6,
        heading: 'Dentures Realignment',
        text: "Impediment from, poison of life, just. There is no such thing as a soft-footed soccer ball. Complete keyboard. Tomorrow's protein.c",
        glHeading: 'Zahnersatz-Neuausrichtung', 
        alHeading: 'إعادة توجيه التركيبات',
        glText: 'Hindernis vom Gift des Lebens, einfach. Es gibt so etwas wie einen weichen Fußball nicht. Komplette Tastatur. Proteinpulver von morgen.', 
        alText: 'عائق من سم الحياة، ببساطة. لا يوجد شيء اسمه كرة قدم ناعمة. لوحة مفاتيح كاملة. بروتين الغد.',
    }
];

const treatmentHistory = [
    {
        quantity: 650,
        heading: '650+ Cosmetic Surgeries',
        text: 'I just wanted to. Etiam sit with orci own eros faucibus tincidunt. Duis leo. Sed Fringilla Mauritius Sit Amet Nibh. Donec walks on the sodales. Thirst consequat',
        glHeading: '650+ Schönheitsoperationen',
        alHeading: '650+ جراحات تجميلية',
        glText: 'Ich wollte nur. Etiam sit mit orci eigenem eros faucibus tincidunt. Duis leo. Sed Fringilla Mauritius Sit Amet Nibh. Donec Spaziergänge auf den Sodales. Durst consequat',
        alText: 'أردت فقط. اجلس مع أوركي الخاصة أون آمت إيروس فوكيبوس تينكيديونت. دويس ليو. سد فرينجيلا موريشيوس سيت أميت نيبه. دونيك يمشي على السوداليس. العطش consequat',
    },
    {
        quantity: 250,
        heading: '2500+ Root Canal Treatments',
        text: 'I just wanted to. Etiam sit with orci own eros faucibus tincidunt. Duis leo. Sed Fringilla Mauritius Sit Amet Nibh. Donec walks on the sodales. Thirst consequat',
        glHeading: '2500+ Wurzelkanalbehandlungen',
        alHeading: '2500+ علاجات قناة الجذر',
        glText: 'Ich wollte nur. Etiam sit mit orci eigenem eros faucibus tincidunt. Duis leo. Sed Fringilla Mauritius Sit Amet Nibh. Donec Spaziergänge auf den Sodales. Durst consequat',
        alText: 'أردت فقط. اجلس مع أوركي الخاصة أون آمت إيروس فوكيبوس تينكيديونت. دويس ليو. سد فرينجيلا موريشيوس سيت أميت نيبه. دونيك يمشي على السوداليس. العطش consequat',
    },
    {
        quantity: 150,
        heading: '150+ Pediatric Surgeries',
        text: 'I just wanted to. Etiam sit with orci own eros faucibus tincidunt. Duis leo. Sed Fringilla Mauritius Sit Amet Nibh. Donec walks on the sodales. Thirst consequat',
        glHeading: '150+ Kinderchirurgien',
        alHeading: '150+ جراحات الأطفال',
        glText: 'Ich wollte nur. Etiam sit mit orci eigenem eros faucibus tincidunt. Duis leo. Sed Fringilla Mauritius Sit Amet Nibh. Donec Spaziergänge auf den Sodales. Durst consequat',
        alText: 'أردت فقط. اجلس مع أوركي الخاصة أون آمت إيروس فوكيبوس تينكيديونت. دويس ليو. سد فرينجيلا موريشيوس سيت أميت نيبه. دونيك يمشي على السوداليس. العطش consequat',
    }
];

const doctorsData = [
    {
        img: doctor_img_1,
        name: 'JAMES GANDOLFINI',
        role: 'Dental Surgeon',
        text: 'Restorative dentistry is about the restoration of the functional and esthetic.',
        glName: 'JAMES GANDOLFINI',
        alName: 'جيمس غاندولفيني',
        glRole: 'Zahnarzt',
        alRole: 'جراح أسنان',
        glText: 'Restaurative Zahnmedizin geht um die Wiederherstellung der funktionalen und ästhetischen.',
        alText: 'طب الأسنان الترميمي يتعلق بإعادة ترميم الوظيفية والجمالية.',
    },
    {
        img: doctor_img_3,
        name: 'GANDOLFINI',
        role: 'Periodontist',
        text: 'Restoring the structure surrounding & supporting the teeth.',
        glName: 'GANDOLFINI',
        alName: 'غاندولفيني',
        glRole: 'Parodontologe',
        alRole: 'طبيب أمراض اللثة',
        glText: 'Wiederherstellung der die Zähne umgebenden und unterstützenden Struktur.',
        alText: 'استعادة الهيكل المحيط والداعم للأسنان.',
    },
    {
        img: doctor_img_2,
        name: 'CANDALINE TREVIS',
        role: 'Orhodontist',
        text: 'Cosmetic dentistry is about improving the appearance of teeth and gums.',
        glName: 'CANDALINE TREVIS',
        alName: 'كاندالين تريفيس',
        glRole: 'Kieferorthopäde',
        alRole: 'طبيب تقويم الأسنان',
        glText: 'Kosmetische Zahnmedizin geht um die Verbesserung des Aussehens von Zähnen und Zahnfleisch.',
        alText: 'طب الأسنان التجميلي يتعلق بتحسين مظهر الأسنان واللثة.',
    },
    {
        img: doctor_img_4,
        name: 'LINDA TREVIS',
        role: 'Pediatrician',
        text: 'Pediatric dentistry is concerned with the oral hygiene of children from birth to adolescence.',
        glName: 'LINDA TREVIS',
        alName: 'ليندا تريفيس',
        glRole: 'Kinderarzt',
        alRole: 'طبيب أطفال',
        glText: 'Kinderzahnheilkunde befasst sich mit der Mundhygiene von Kindern von der Geburt bis zur Adoleszenz.',
        alText: 'طب الأسنان الأطفال يهتم بالنظافة الشخصية للأطفال من الولادة إلى المراهقة.',
    }
];

const dentalSpecialities = [
    {
        name: 'Cosmetic Dentistry',
        text: 'Lorem ipsum pain sit amet, consectetuer adipiscing elite, because they nonummy nibh euismod tincidunt out laoreet pain. Phasellus nursery null out metus.',
        glName: 'Kosmetische Zahnmedizin',
        alName: 'طب الأسنان التجميلي',
        glText: 'Lorem ipsum Schmerz sit amet, consectetuer adipiscing Elite, weil sie nonummy nibh euismod tincidunt out Laoreet Schmerz. Phasellus Kindergarten null aus Metus.',
        alText: 'لوريم إيبسوم الم آميت، كونسيكتيتور adipiscing النخبة، لأنها nonummy nibh euismod tincidunt out laoreet الألم. بأسيللوس حضانة الحضانة الحضانة من الأطفال.',
    },
    {
        name: 'Restorative Dentistry',
        text: 'Lorem ipsum pain sit amet, consectetuer adipiscing elite, because they nonummy nibh euismod tincidunt out laoreet pain. Phasellus nursery null out metus.',
        glName: 'Restaurative Zahnmedizin',
        alName: 'طب الأسنان الترميمي',
        glText: 'Lorem ipsum Schmerz sit amet, consectetuer adipiscing Elite, weil sie nonummy nibh euismod tincidunt out Laoreet Schmerz. Phasellus Kindergarten null aus Metus.',
        alText: 'لوريم إيبسوم الم آميت، كونسيكتيتور adipiscing النخبة، لأنها nonummy nibh euismod tincidunt out laoreet الألم. بأسيللوس حضانة الحضانة الحضانة من الأطفال.',
    },
    {
        name: 'Pediatric Dentistry',
        text: 'Lorem ipsum pain sit amet, consectetuer adipiscing elite, because they nonummy nibh euismod tincidunt out laoreet pain. Phasellus nursery null out metus.',
        glName: 'Kinderzahnheilkunde',
        alName: 'طب الأسنان الأطفال',
        glText: 'Lorem ipsum Schmerz sit amet, consectetuer adipiscing Elite, weil sie nonummy nibh euismod tincidunt out Laoreet Schmerz. Phasellus Kindergarten null aus Metus.',
        alText: 'لوريم إيبسوم الم آميت، كونسيكتيتور adipiscing النخبة، لأنها nonummy nibh euismod tincidunt out laoreet الألم. بأسيللوس حضانة الحضانة الحضانة من الأطفال.',
    },
    {
        name: 'Geriatric Dentistry',
        text: 'Lorem ipsum pain sit amet, consectetuer adipiscing elite, because they nonummy nibh euismod tincidunt out laoreet pain. Phasellus nursery null out metus.',
        glName: 'Geriatrische Zahnmedizin',
        alName: 'طب الأسنان للكبار',
        glText: 'Lorem ipsum Schmerz sit amet, consectetuer adipiscing Elite, weil sie nonummy nibh euismod tincidunt out Laoreet Schmerz. Phasellus Kindergarten null aus Metus.',
        alText: 'لوريم إيبسوم الم آميت، كونسيكتيتور adipiscing النخبة، لأنها nonummy nibh euismod tincidunt out laoreet الألم. بأسيللوس حضانة الحضانة الحضانة من الأطفال.',
    }
];

const locationData = [
    {
        img: location_img_1,
        name: 'Hogwarts, HP',
        text1: '3524 Deerfield Drive',
        text2: 'Valdosta, GA 31601',
        text3: '(973) 486-4862',
        glName: 'Hogwarts, HP',
        alName: 'هوغوارتس، هاري بوتر',
        glText1: '3524 Hirschfeld Drive',
        alText1: 'شارع هيرشفيلد 3524',
        glText2: 'Valdosta, GA 31601',
        alText2: 'فالدوستا، جورجيا 31601',
    },
    {
        img: location_img_2,
        name: 'Hoboken, NJ',
        text1: '1995 Briarwood Drive',
        text2: 'Mount Vernon, NY 10550',
        text3: '(973) 780-5805',
        glName: 'Hoboken, NJ',
        alName: 'هوبوكين، نيو جيرسي',
        glText1: '1995 Briarwood Drive',
        alText1: 'شارع برياروود 1995',
        glText2: 'Mount Vernon, NY 10550',
        alText2: 'ماونت فيرنون، نيويورك 10550',
    },
    {
        img: location_img_3,
        name: 'Cambridge, NJ',
        text1: '9543 State Street',
        text2: 'Union, NJ 07083',
        text3: '(973) 486-4862',
        glName: 'Cambridge, NJ',
        alName: 'كامبريدج، نيو جيرسي',
        glText1: '9543 State Street',
        alText1: 'شارع ستيت 9543',
        glText2: 'Union, NJ 07083',
        alText2: 'اتحاد، نيو جيرسي 07083',
    }
];

const dentistryData = [
    {
        icon: <FaHospital />,
        name: 'DENTAL CLEANING & FILLING',
        text1: "But it's funny",
        text2: 'But the result is timing',
        text3: 'Members with great arrows',
        text4: 'But the result is timing',
        glName: 'ZAHNREINIGUNG & FÜLLUNG',
        alName: 'تنظيف وحشو أسنان',
        glText1: 'Aber es ist lustig',
        alText1: 'لكنه مضحك',
        glText2: 'Aber das Ergebnis ist Zeitmessung',
        alText2: 'ولكن النتيجة هي التوقيت',
        glText3: 'Mitglieder mit großartigen Pfeilen',
        alText3: 'أعضاء بسهام عظيمة',
        glText4: 'Aber das Ergebnis ist Zeitmessung',
        alText4: 'ولكن النتيجة هي التوقيت'
    },
    {
        icon: <FaUserDoctor />,
        name: 'ROOT CANAL TREATMENTS RCT',
        text1: "But it's funny",
        text2: 'But the result is timing',
        text3: 'Members with great arrows',
        text4: 'But the result is timing',
        glName: 'WURZELKANALBEHANDLUNGEN RCT',
        alName: 'علاج قناة الجذر',
        glText1: 'Aber es ist lustig',
        alText1: 'لكنه مضحك',
        glText2: 'Aber das Ergebnis ist Zeitmessung',
        alText2: 'ولكن النتيجة هي التوقيت',
        glText3: 'Mitglieder mit großartigen Pfeilen',
        alText3: 'أعضاء بسهام عظيمة',
        glText4: 'Aber das Ergebnis ist Zeitmessung',
        alText4: 'ولكن النتيجة هي التوقيت'
    },
    {
        icon: <GiFirstAidKit />,
        name: 'IMPLANTS & BRACES',
        text1: "But it's funny",
        text2: 'But the result is timing',
        text3: 'Members with great arrows',
        text4: 'But the result is timing',
        glName: 'IMPLANTATE & SPANGEN',
        alName: 'الزرعات والأقواس السنية',
        glText1: 'Aber es ist lustig',
        alText1: 'لكنه مضحك',
        glText2: 'Aber das Ergebnis ist Zeitmessung',
        alText2: 'ولكن النتيجة هي التوقيت',
        glText3: 'Mitglieder mit großartigen Pfeilen',
        alText3: 'أعضاء بسهام عظيمة',
        glText4: 'Aber das Ergebnis ist Zeitmessung',
        alText4: 'ولكن النتيجة هي التوقيت'
    },
    {
        icon: <FaHeartPulse />,
        name: 'PORCELAIN VENEERS',
        text1: "But it's funny",
        text2: 'But the result is timing',
        text3: 'Members with great arrows',
        text4: 'But the result is timing',
        glName: 'PORZELLAN-FURNIERE',
        alName: 'تقشير البورسلين',
        glText1: 'Aber es ist lustig',
        alText1: 'لكنه مضحك',
        glText2: 'Aber das Ergebnis ist Zeitmessung',
        alText2: 'ولكن النتيجة هي التوقيت',
        glText3: 'Mitglieder mit großartigen Pfeilen',
        alText3: 'أعضاء بسهام عظيمة',
        glText4: 'Aber das Ergebnis ist Zeitmessung',
        alText4: 'ولكن النتيجة هي التوقيت'
    }
];

const procedureData = [
    {
        imageUrl: procedure_img_1,
        heading: 'Dental Filling',
        text: 'The children are either laughing or laughing. Now it is sad in the hendrerit fringilla. The children live in the disease of old age and the grandchildren and the males.',
        path: allPaths?.PROCEDUREDENTALFILLING,
        glHeading: 'Zahnfüllung',
        alHeading: 'حشو الأسنان',
        glText: 'Die Kinder lachen entweder oder lachen. Jetzt ist es traurig im Hendrerit-Fringilla. Die Kinder leben in der Krankheit des Alters und der Enkel und der Männer.',
        alText: 'الأطفال إما يضحكون أو يضحكون. الآن هو حزين في هندريريت فرينجيلا. يعيش الأطفال في مرض الشيخوخة والأحفاد والذكور.'
    },
    {
        imageUrl: procedure_img_2,
        heading: 'Dentistry',
        text: 'For what now, flatters or, mourns the pulvinar, hendrerit id, lorem. Maecenas did not hate and before tincidunt time. Until life.',
        path: allPaths?.PROCEDUREDENTISTRY,
        glHeading: 'Zahnmedizin',
        alHeading: 'طب الأسنان',
        glText: 'Wofür jetzt, schmeichelt oder trauert der Pulvinar, Hendrerit-ID, Lorem. Maecenas hasste nicht und bevor tincidunt-Zeit. Bis zum Leben.',
        alText: 'لماذا الآن، يطلب أو ينعى البولفينار، هندريريت id، لوريم. لم يكره مايسيناس وقبل وقت تينكيدونت. حتى الحياة.'
    },
    {
        imageUrl: procedure_img_3,
        heading: 'Dental Bridges',
        text: 'Maecenas did not hate and before tincidunt time. Until the end of life. For what now, flatters or, mourns the pulvinar, hendrerit id, lorem.',
        path: allPaths?.PROCEDUREDENTALBRIDGES,
        glHeading: 'Zahnbrücken',
        alHeading: 'الجسور السنية',
        glText: 'Maecenas hasste nicht und bevor tincidunt-Zeit. Bis zum Ende des Lebens. Wofür jetzt, schmeichelt oder trauert der Pulvinar, Hendrerit-ID, Lorem.',
        alText: 'لم يكره مايسيناس وقبل وقت تينكيدونت. حتى نهاية الحياة. لماذا الآن، يطلب أو ينعى البولفينار، هندريريت id، لوريم.'
    },
    {
        imageUrl: procedure_img_4,
        heading: 'Veneers',
        text: 'For what now, flatters or, mourns the pulvinar, hendrerit id, lorem. Maecenas did not hate and before tincidunt time. Until life.',
        path: allPaths?.PROCEDUREVENEERS,
        glHeading: 'Verblendschalen',
        alHeading: 'التجميل بالتلبيسات',
        glText: 'Wofür jetzt, schmeichelt oder trauert der Pulvinar, Hendrerit-ID, Lorem. Maecenas hasste nicht und bevor tincidunt-Zeit. Bis zum Leben.',
        alText: 'لماذا الآن، يطلب أو ينعى البولفينار، هندريريت id، لوريم. لم يكره مايسيناس وقبل وقت تينكيدونت. حتى الحياة.'
    },
    {
        imageUrl: procedure_img_5,
        heading: 'Invisalign',
        text: 'The children are either laughing or laughing. Now it is sad in the hendrerit fringilla. The children live in the disease of old age and the grandchildren and the males.',
        path: allPaths?.PROCEDUREINVISALIGN,
        glHeading: 'Invisalign',
        alHeading: 'إنفيزالين',
        glText: 'Die Kinder lachen entweder oder lachen. Jetzt ist es traurig im Hendrerit-Fringilla. Die Kinder leben in der Krankheit des Alters und der Enkel und der Männer.',
        alText: 'الأطفال إما يضحكون أو يضحكون. الآن هو حزين في هندريريت فرينجيلا. يعيش الأطفال في مرض الشيخوخة والأحفاد والذكور.'
    },
    {
        imageUrl: procedure_img_6,
        heading: 'Crowns',
        text: 'Maecenas did not hate and before tincidunt time. Until the end of life. For what now, flatters or, mourns the pulvinar, hendrerit id, lorem.',
        path: allPaths?.PROCEDURECROWNS,
        glHeading: 'Kronen',
        alHeading: 'تاج السن',
        glText: 'Maecenas hasste nicht und bevor tincidunt-Zeit. Bis zum Ende des Lebens. Wofür jetzt, schmeichelt oder trauert der Pulvinar, Hendrerit-ID, Lorem.',
        alText: 'لم يكره مايسيناس وقبل وقت تينكيدونت. حتى نهاية الحياة. لماذا الآن، يطلب أو ينعى البولفينار، هندريريت id، لوريم.'
    }
];

const aboutData = [
    {
        imageUrl: aboutImg1,
        heading: 'DENTAL EXPLORERS & DRILL',
        text: 'The customer is very important, the customer will be followed by the customer. Morbi hendrerit elit turpis.',
        glHeading: 'ZAHNÄRZTLICHE FORSCHER & BOHRER',
        alHeading: 'المستكشفين والمثقاب السني',
        glText: 'Der Kunde ist sehr wichtig, der Kunde wird vom Kunden verfolgt. Morbi hendrerit elit turpis.',
        alText: 'العميل مهم جدًا، سيتم متابعة العميل من قبل العميل. موربي هيندريرت إليت توربيس.'
    },
    {
        imageUrl: aboutImg2,
        heading: 'MIRROR, MIRROR ON THE ROD',
        text: 'The customer is very important, the customer will be followed by the customer. Morbi hendrerit elit turpis.',
        glHeading: 'SPIEGEL, SPIEGEL AM STAB',
        alHeading: 'مرآة، مرآة على العصا',
        glText: 'Der Kunde ist sehr wichtig, der Kunde wird vom Kunden verfolgt. Morbi hendrerit elit turpis.',
        alText: 'العميل مهم جدًا، سيتم متابعة العميل من قبل العميل. موربي هيندريرت إليت توربيس.'
    },
    {
        imageUrl: aboutImg3,
        heading: 'DENTAL EXTRACTION PROCEDURE',
        text: 'The customer is very important, the customer will be followed by the customer. Morbi hendrerit elit turpis.',
        glHeading: 'ZAHNENTFERNUNGSVERFAHREN',
        alHeading: 'إجراء استخراج الأسنان',
        glText: 'Der Kunde ist sehr wichtig, der Kunde wird vom Kunden verfolgt. Morbi hendrerit elit turpis.',
        alText: 'العميل مهم جدًا، سيتم متابعة العميل من قبل العميل. موربي هيندريرت إليت توربيس.'
    }
];

const aboutFaqs = [
    {
        question: 'What type of dental care is best for you?',
        answer: 'They are about to receive two troubles, blinded by desire, they do not provide for them, and they are similarly guilty of those who abandon their duties because of the softness of their mind, that is, the flight of toils and sorrows. And indeed the distinction between these things is easy and expedient. And indeed the distinction between these things is easy and expedient. They are going to have two problems',
        glQuestion: 'Was für eine Art von zahnärztlicher Pflege ist am besten für Sie?',
        alQuestion: 'ما نوع الرعاية السنية الأفضل لك؟',
        glAnswer: 'Sie sind gerade dabei, zwei Probleme zu bekommen, geblendet von Verlangen, sie kümmern sich nicht darum, und sie sind ähnlich schuldig wie diejenigen, die ihre Pflichten wegen der Weichheit ihres Geistes, das heißt, der Flucht vor Mühen und Leiden, vernachlässigen. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Sie werden zwei Probleme bekommen.',
        alAnswer: 'هم على وشك تلقي مشكلتين، مسلوبي البصر بسبب الرغبة، لا يقدمون لهم الاهتمام، وهم مذنبون بنفس القدر مثل الذين يتخلون عن واجباتهم بسبب ضعف أذهانهم، أي هروب من المتاعب والأحزان. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. إنهم على وشك مواجهة مشكلتين.',
    },
    {
        question: 'How to protect the tooth?',
        answer: 'They are about to receive two troubles, blinded by desire, they do not provide for them, and they are similarly guilty of those who abandon their duties because of the softness of their mind, that is, the flight of toils and sorrows. And indeed the distinction between these things is easy and expedient. And indeed the distinction between these things is easy and expedient. They are going to have two problems',
        glQuestion: 'Wie schützt man den Zahn?',
        alQuestion: 'كيفية حماية السن؟',
        glAnswer: 'Sie sind gerade dabei, zwei Probleme zu bekommen, geblendet von Verlangen, sie kümmern sich nicht darum, und sie sind ähnlich schuldig wie diejenigen, die ihre Pflichten wegen der Weichheit ihres Geistes, das heißt, der Flucht vor Mühen und Leiden, vernachlässigen. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Sie werden zwei Probleme bekommen.',
        alAnswer: 'هم على وشك تلقي مشكلتين، مسلوبي البصر بسبب الرغبة، لا يقدمون لهم الاهتمام، وهم مذنبون بنفس القدر مثل الذين يتخلون عن واجباتهم بسبب ضعف أذهانهم، أي هروب من المتاعب والأحزان. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. إنهم على وشك مواجهة مشكلتين.',
    },
    {
        question: 'How often should one floss the teeth?',
        answer: 'They are about to receive two troubles, blinded by desire, they do not provide for them, and they are similarly guilty of those who abandon their duties because of the softness of their mind, that is, the flight of toils and sorrows. And indeed the distinction between these things is easy and expedient. And indeed the distinction between these things is easy and expedient. They are going to have two problems',
        glQuestion: 'Wie oft sollte man die Zähne mit Zahnseide reinigen?',
        alQuestion: 'كم مرة يجب استخدام خيط الأسنان؟',
        glAnswer: 'Sie sind gerade dabei, zwei Probleme zu bekommen, geblendet von Verlangen, sie kümmern sich nicht darum, und sie sind ähnlich schuldig wie diejenigen, die ihre Pflichten wegen der Weichheit ihres Geistes, das heißt, der Flucht vor Mühen und Leiden, vernachlässigen. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Sie werden zwei Probleme bekommen.',
        alAnswer: 'هم على وشك تلقي مشكلتين، مسلوبي البصر بسبب الرغبة، لا يقدمون لهم الاهتمام، وهم مذنبون بنفس القدر مثل الذين يتخلون عن واجباتهم بسبب ضعف أذهانهم، أي هروب من المتاعب والأحزان. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. إنهم على وشك مواجهة مشكلتين.',
    },
    {
        question: 'Use mouthwash regularly for better oral hygiene?',
        answer: 'They are about to receive two troubles, blinded by desire, they do not provide for them, and they are similarly guilty of those who abandon their duties because of the softness of their mind, that is, the flight of toils and sorrows. And indeed the distinction between these things is easy and expedient. And indeed the distinction between these things is easy and expedient. They are going to have two problems',
        glQuestion: 'Mundspülung regelmäßig für bessere Mundhygiene verwenden?',
        alQuestion: 'هل يجب استخدام مضمضة الفم بانتظام للنظافة الفموية؟',
        glAnswer: 'Sie sind gerade dabei, zwei Probleme zu bekommen, geblendet von Verlangen, sie kümmern sich nicht darum, und sie sind ähnlich schuldig wie diejenigen, die ihre Pflichten wegen der Weichheit ihres Geistes, das heißt, der Flucht vor Mühen und Leiden, vernachlässigen. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Sie werden zwei Probleme bekommen.',
        alAnswer: 'هم على وشك تلقي مشكلتين، مسلوبي البصر بسبب الرغبة، لا يقدمون لهم الاهتمام، وهم مذنبون بنفس القدر مثل الذين يتخلون عن واجباتهم بسبب ضعف أذهانهم، أي هروب من المتاعب والأحزان. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. إنهم على وشك مواجهة مشكلتين.',
    },
    {
        question: 'Care for your teeth by quitting smoking?',
        answer: 'They are about to receive two troubles, blinded by desire, they do not provide for them, and they are similarly guilty of those who abandon their duties because of the softness of their mind, that is, the flight of toils and sorrows. And indeed the distinction between these things is easy and expedient. And indeed the distinction between these things is easy and expedient. They are going to have two problems',
        glQuestion: 'Pflegen Sie Ihre Zähne, indem Sie das Rauchen aufgeben?',
        alQuestion: 'هل تعتني بأسنانك من خلال التوقف عن التدخين؟',
        glAnswer: 'Sie sind gerade dabei, zwei Probleme zu bekommen, geblendet von Verlangen, sie kümmern sich nicht darum, und sie sind ähnlich schuldig wie diejenigen, die ihre Pflichten wegen der Weichheit ihres Geistes, das heißt, der Flucht vor Mühen und Leiden, vernachlässigen. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Und tatsächlich ist die Unterscheidung zwischen diesen Dingen einfach und zweckmäßig. Sie werden zwei Probleme bekommen.',
        alAnswer: 'هم على وشك تلقي مشكلتين، مسلوبي البصر بسبب الرغبة، لا يقدمون لهم الاهتمام، وهم مذنبون بنفس القدر مثل الذين يتخلون عن واجباتهم بسبب ضعف أذهانهم، أي هروب من المتاعب والأحزان. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. وفي الواقع، التمييز بين هذه الأشياء سهل ومفيد. إنهم على وشك مواجهة مشكلتين.',
    }
];

const modernTitle = [
    {
        imageUrl: ModernTitle1,
        heading: 'Tomorrow will be a sad day, not a lake',
        name: 'Veneers',
        glHeading: 'Morgen wird ein trauriger Tag sein, kein See',
        alHeading: 'سيكون غدا يومًا حزينًا، وليس بحيرة',
        glName: 'Verblendungen',
        alName: 'تغطيات الأسنان',
        path: allPaths?.PORTFOLIOCARD1
    },
    {
        imageUrl: ModernTitle2,
        heading: 'To trigger the yeast',
        name: 'Cosmetic',
        glHeading: 'Um die Hefe auszulösen',
        alHeading: 'لتحفيز الخميرة',
        glName: 'Kosmetik',
        alName: 'مستحضرات التجميل',
        path: allPaths?.PORTFOLIOCARD2
    },
    {
        imageUrl: ModernTitle3,
        heading: 'Everyone has that important time',
        name: 'Invisalign',
        glHeading: 'Jeder hat diese wichtige Zeit',
        alHeading: 'كل شخص لديه هذا الوقت المهم',
        glName: 'Unsichtbare Zahnspange',
        alName: 'تقويم شفاف',
        path: allPaths?.PORTFOLIOCARD3
    },
    {
        imageUrl: ModernTitle4,
        heading: 'It is a poisonous trigger',
        name: 'Braces',
        glHeading: 'Es ist ein giftiger Auslöser',
        alHeading: 'إنه محفز سام',
        glName: 'Zahnspangen',
        alName: 'تقويم الأسنان',
        path: allPaths?.PORTFOLIOCARD4
    },
    {
        imageUrl: ModernTitle5,
        heading: 'Aenean vitae enim rhoncus',
        name: 'Cosmetic',
        glHeading: 'Aenean vitae enim rhoncus',
        alHeading: 'Aenean vitae enim rhoncus',
        glName: 'Kosmetik',
        alName: 'مستحضرات التجميل',
        path: allPaths?.PORTFOLIOCARD5
    },
    {
        imageUrl: ModernTitle6,
        heading: 'Unfortunately, it is the biggest promotion',
        name: 'Braces',
        glHeading: 'Leider ist es die größte Förderung',
        alHeading: 'لسوء الحظ، إنه أكبر ترويج',
        glName: 'Zahnspangen',
        alName: 'تقويم الأسنان',
        path: allPaths?.PORTFOLIOCARD6
    },
    {
        imageUrl: ModernTitle7,
        heading: 'Fear of children',
        name: 'Implants',
        glHeading: 'Angst vor Kindern',
        alHeading: 'خوف الأطفال',
        glName: 'Implantate',
        alName: 'زرع الأسنان',
        path: allPaths?.PORTFOLIOCARD7
    },
    {
        imageUrl: ModernTitle8,
        heading: 'No CNN is made of advertising',
        name: 'Invisalign',
        glHeading: 'Kein CNN besteht aus Werbung',
        alHeading: 'لا يوجد CNN مصنوع من الإعلانات',
        glName: 'Unsichtbare Zahnspange',
        alName: 'تقويم شفاف',
        path: allPaths?.PORTFOLIOCARD8
    },
    {
        imageUrl: ModernTitle9,
        heading: 'Some of them are wise',
        name: 'Veneers',
        glHeading: 'Einige von ihnen sind weise',
        alHeading: 'بعضهم حكيم',
        glName: 'Verblendungen',
        alName: 'تغطيات الأسنان',
        path: allPaths?.PORTFOLIOCARD9
    },
    {
        imageUrl: ModernTitle10,
        heading: 'Maurice neither now nor now',
        name: 'Cosmetic',
        glHeading: 'Maurice weder jetzt noch jetzt',
        alHeading: 'موريس ليس الآن ولا الآن',
        glName: 'Kosmetik',
        alName: 'مستحضرات التجميل',
        path: allPaths?.PORTFOLIOCARD10
    },
    {
        imageUrl: ModernTitle11,
        heading: 'Fusce at semper tellus',
        name: 'Implants',
        glHeading: 'Fusce at semper tellus',
        alHeading: 'Fusce at semper tellus',
        glName: 'Implantate',
        alName: 'زرع الأسنان',
        path: allPaths?.PORTFOLIOCARD11
    },
    {
        imageUrl: ModernTitle12,
        heading: 'Time to target the target time',
        name: 'Invisalign',
        glHeading: 'Zeit, um die Zielzeit zu erreichen',
        alHeading: 'الوقت لتحقيق الوقت المستهدف',
        glName: 'Unsichtbare Zahnspange',
        alName: 'تقويم شفاف',
        path: allPaths?.PORTFOLIOCARD12
    },
];

const aboutPricingCardData = [
    {
        name: 'Basic Dentistry',
        text: 'Best price for oral treatments',
        price: '99',
        features: [
            "Dental fillings",
            "Number of Teeth",
            "Oral surgery",
            "Dental veneers",
            "Teeth whitening",
            "Crowns and bridges",
            "Lipid Profile",
            "Dentures",
            "Dental fillings",
            "Number of Teeth",
            "Oral surgery"
        ],
        glName: 'Grundzahnheilkunde',
        alName: 'طب أسنان الأساسي',
        glText: 'Bester Preis für orale Behandlungen',
        alText: 'أفضل سعر للعلاجات الفموية',
        glFeatures: [
            "Zahnfüllungen",
            "Anzahl der Zähne",
            "Mundchirurgie",
            "Zahnverblendungen",
            "Zahnaufhellung",
            "Kronen und Brücken",
            "Lipidprofil",
            "Zahnersatz"
        ],
        alFeatures: [
            "حشوات الأسنان",
            "عدد الأسنان",
            "جراحة الفم",
            "تطريحات الأسنان",
            "تبييض الأسنان",
            "تاج وجسور",
            "ملف الدهون",
            "الأسنان الاصطناعية"
        ]
    },
    {
        name: 'Cosmetic Dentistry',
        text: 'Best price for oral treatments',
        price: '89',
        features: [
            "Dental fillings",
            "Number of Teeth",
            "Oral surgery",
            "Dental veneers",
            "Teeth whitening",
            "Crowns and bridges",
            "Lipid Profile",
            "Dentures",
            "Dental fillings",
            "Number of Teeth",
            "Oral surgery",
            "Dental veneers"
        ],
        glName: 'Kosmetische Zahnheilkunde',
        alName: 'طب الأسنان التجميلي',
        glText: 'Bester Preis für orale Behandlungen',
        alText: 'أفضل سعر للعلاجات الفموية',
        glFeatures: [
            "Zahnfüllungen",
            "Anzahl der Zähne",
            "Mundchirurgie",
            "Zahnverblendungen",
            "Zahnaufhellung",
            "Kronen und Brücken",
            "Lipidprofil",
            "Zahnersatz",
            "Zahnverblendungen"
        ],
        alFeatures: [
            "حشوات الأسنان",
            "عدد الأسنان",
            "جراحة الفم",
            "تطريحات الأسنان",
            "تبييض الأسنان",
            "تاج وجسور",
            "ملف الدهون",
            "الأسنان الاصطناعية",
            "تطريحات الأسنان"
        ]
    },
    {
        name: 'Re-Constructive+',
        text: 'Best price for oral treatments',
        price: '99',
        features: [
            "Dental fillings",
            "Number of Teeth",
            "Oral surgery",
            "Dental veneers",
            "Teeth whitening",
            "Crowns and bridges",
            "Lipid Profile",
            "Dentures",
            "Dental fillings",
            "Number of Teeth",
            "Oral surgery",
            "Dental veneers",
            "Teeth whitening",
            "Crowns and bridges"
        ],
        glName: 'Rekonstruktive Zahnheilkunde',
        alName: 'طب الأسنان الترميمي+',
        glText: 'Bester Preis für orale Behandlungen',
        alText: 'أفضل سعر للعلاجات الفموية',
        glFeatures: [
            "Zahnfüllungen",
            "Anzahl der Zähne",
            "Mundchirurgie",
            "Zahnverblendungen",
            "Zahnaufhellung",
            "Kronen und Brücken",
            "Lipidprofil",
            "Zahnersatz",
            "Zahnverblendungen",
            "Zahnaufhellung",
            "Kronen und Brücken"
        ],
        alFeatures: [
            "حشوات الأسنان",
            "عدد الأسنان",
            "جراحة الفم",
            "تطريحات الأسنان",
            "تبييض الأسنان",
            "تاج وجسور",
            "ملف الدهون",
            "الأسنان الاصطناعية",
            "تطريحات الأسنان",
            "تبييض الأسنان",
            "تاج وجسور",
        ]
    }
];


const aboutSolutionData = [
    {
        img: aboutSolutionTeethImg,
        heading: 'Are you Loosing your Teeth?',
        description: 'For existing dental problems',
        text: 'Recognizing the signs your teeth may fall out is crucial for preserving dental health. Loose teeth, gum recession, toothache and sensitivity.',
        glHeading: 'Verlieren Sie Ihre Zähne?',
        alHeading: 'هل تفقد أسنانك؟',
        glDescription: 'Für bestehende Zahnprobleme',
        alDescription: 'لمشاكل الأسنان الحالية',
        glText: 'Die Anzeichen dafür, dass Ihre Zähne ausfallen können, zu erkennen, ist entscheidend für die Erhaltung der Zahngesundheit. Lockere Zähne, Zahnfleischrückgang, Zahnschmerzen und Empfindlichkeit.',
        alText: 'التعرف على علامات أن أسنانك قد تتساقط أمر مهم للحفاظ على الصحة السنية. الأسنان الطافية، تراجع اللثة، وجع الأسنان والحساسية.'
    },
    {
        img: aboutSolutionSwimImg,
        heading: 'Need a Solution?',
        description: 'For existing dental problems',
        text: 'Recognizing the signs your teeth may fall out is crucial for preserving dental health. Loose teeth, gum recession, toothache and sensitivity.',
        glHeading: 'Brauchen Sie eine Lösung?',
        alHeading: 'هل تحتاج إلى حل؟',
        glDescription: 'Für bestehende Zahnprobleme',
        alDescription: 'لمشاكل الأسنان الحالية',
        glText: 'Die Anzeichen dafür, dass Ihre Zähne ausfallen können, zu erkennen, ist entscheidend für die Erhaltung der Zahngesundheit. Lockere Zähne, Zahnfleischrückgang, Zahnschmerzen und Empfindlichkeit.',
        alText: 'التعرف على علامات أن أسنانك قد تتساقط أمر مهم للحفاظ على الصحة السنية. الأسنان الطافية، تراجع اللثة، وجع الأسنان والحساسية.'
    }
];

const aboutDentalCareData = [
    {
        icon: <FaUserDoctor />,
        heading: '24/7 Live Support',
        text: 'Choose the type of department and your staff along with the time slot',
        glHeading: '24/7 Live-Support',
        alHeading: 'الدعم المباشر على مدار الساعة',
        glText: 'Wählen Sie die Art der Abteilung und Ihr Personal zusammen mit dem Zeitfenster',
        alText: 'اختر نوع القسم وموظفيك مع الفترة الزمنية'
    },
    {
        icon: <FaHeadset />,
        heading: '24/7 Live Support',
        text: 'Choose the type of department and your staff along with the time slot',
        glHeading: '24/7 Live-Support',
        alHeading: 'الدعم المباشر على مدار الساعة',
        glText: 'Wählen Sie die Art der Abteilung und Ihr Personal zusammen mit dem Zeitfenster',
        alText: 'اختر نوع القسم وموظفيك مع الفترة الزمنية'
    }
];

const initialShopData = [
    {
        img: shopImg1,
        name: 'Braces',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 18,
        glName: 'Klammern',
        alName: 'الأقواس السنية'
    },
    {
        img: shopImg2,
        name: 'Dental Braces',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 15,
        glName: 'Zahnspangen',
        alName: 'الأقواس السنية'
    },
    {
        img: shopImg3,
        name: 'Dental Floss Brush',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 15,
        glName: 'Zahnseidebürste',
        alName: 'فرشاة خيط الأسنان'
    },
    {
        img: shopImg4,
        name: 'Dental Implants Type I',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 20,
        glName: 'Zahnimplantate Typ I',
        alName: 'زرعات الأسنان النوع الأول'
    },
    {
        img: shopImg5,
        name: 'Dental Implants Type II',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 20,
        glName: 'Zahnimplantate Typ II',
        alName: 'زرعات الأسنان النوع الثاني'
    },
    {
        img: shopImg6,
        name: 'Denture Brushes',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 12,
        glName: 'Prothesenbürsten',
        alName: 'فرشاة السنانير'
    },
    {
        img: shopImg7,
        name: 'Denture With Box',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 18,
        glName: 'Prothesen mit Box',
        alName: 'الأسنان المستعارة مع صندوق'
    },
    {
        img: shopImg8,
        name: 'InterDental Brushes & Floss Set',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 35,
        glName: 'Interdentale Bürsten & Zahnseide-Set',
        alName: 'فرشاة الأسنان البينية ومجموعة الخيط'
    },
    {
        img: shopImg9,
        name: 'Jetpik Floss Brush',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 35,
        glName: 'Jetpik Zahnseidenbürste',
        alName: 'فرشاة خيط Jetpik'
    },
    {
        img: shopImg10,
        name: 'Mouth Rinse Liquid',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 20,
        glName: 'Mundspüllösung',
        alName: 'سائل شطف الفم'
    },
    {
        img: shopImg16,
        name: 'MouthWash Liquid',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 15,
        glName: 'Mundspüllösung',
        alName: 'سائل شطف الفم'
    },
    {
        img: shopImg15,
        name: 'Oral Irrigator',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 35,
        glName: 'Munddusche',
        alName: 'مرافق شطف الفم'
    },
    {
        img: shopImg14,
        name: 'Oral Irrigator With Brushes',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 35,
        glName: 'Munddusche mit Bürsten',
        alName: 'مرافق شطف الفم مع الفرشاة'
    },
    {
        img: shopImg13,
        name: 'Single Implants',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 35,
        glName: 'Einzelne Implantate',
        alName: 'زرعات فردية'
    },
    {
        img: shopImg12,
        name: 'Teeth Color Samples',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 35,
        glName: 'Zahnfarbmuster',
        alName: 'عينات لون الأسنان'
    },
    {
        img: shopImg11,
        name: 'Tooth Brush Set',
        rating: <Rate style={{ color: '#61cee5' }} allowHalf defaultValue={2.5} />,
        price: 12,
        glName: 'Zahnbürstenset',
        alName: 'مجموعة فرشاة الأسنان'
    },
];
const procedureDentalList = [
    {
        point: 'Aeneas put the salad on the salad',
        glPoint: 'Aeneas legte den Salat auf den Salat',
        alPoint: 'أينياس وضع السلطة على السلطة'
    },
    {
        point: "But it's always going to be a soft basketball game.",
        glPoint: 'Aber es wird immer ein weiches Basketballspiel sein.',
        alPoint: 'ولكنه سيكون دائمًا لعبة كرة سلة لطيفة.'
    },
    {
        point: 'We live in a car park that wants to live in Lacinia',
        glPoint: 'Wir leben in einem Parkhaus, das in Lacinia leben möchte',
        alPoint: 'نحن نعيش في موقف للسيارات يرغب في العيش في لاسينيا'
    },
    {
        point: 'Curator port nibh id velit feugiat',
        glPoint: 'Kurator Port Nibh id Velit Feugiat',
        alPoint: 'مدير الميناء نيبه القيمة فيوجيات'
    },
    {
        point: 'The flavor of the sauce is like a medicinal cream.',
        glPoint: 'Der Geschmack der Sauce ist wie eine medizinische Creme.',
        alPoint: 'طعم الصلصة مثل الكريمة الطبية.'
    },
    {
        point: 'But my children are at the very time of the quiver',
        glPoint: 'Aber meine Kinder sind gerade zur Zeit des Zitterns',
        alPoint: 'ولكن أطفالي في الوقت الحالي من الرعشة'
    },
    {
        point: 'To put Aenean on his hair, draw him',
        glPoint: 'Um Aenean auf sein Haar zu legen, zieh ihn',
        alPoint: 'لوضع أينياس على شعره ، ارسمه'
    }
];

const procedureDayOneData = [
    {
        img: procedureDayOneimg1,
        name: 'Nonummy Nibh Euismod',
        glName: 'Nicht leeres Lorem',
        alName: 'لوريم غير فارغ نونومي',
        text: 'Recognizing the signs your teeth may fall out is crucial for preserving dental health. Loose teeth, gum recession, toothache and sensitivity.',
        glText: 'Das Erkennen der Anzeichen dafür, dass Ihre Zähne ausfallen können, ist entscheidend für die Erhaltung der Zahngesundheit. Locker sitzende Zähne, Zahnfleischrückgang, Zahnschmerzen und Empfindlichkeit.',
        alText: 'التعرف على علامات قد تسقط أسنانك أمر حاسم للحفاظ على صحة الفم. الأسنان الطافية ، انحدار اللثة ، ألم الأسنان والحساسية.'
    },
    {
        img: procedureDayOneimg2,
        name: 'Nibh Euismod will be followed',
        glName: 'Nibh Euismod wird befolgt',
        alName: 'سيتم اتباع نيبه ايوسمود',
        text: 'Recognizing the signs your teeth may fall out is crucial for preserving dental health. Loose teeth, gum recession, toothache and sensitivity.',
        glText: 'Das Erkennen der Anzeichen dafür, dass Ihre Zähne ausfallen können, ist entscheidend für die Erhaltung der Zahngesundheit. Locker sitzende Zähne, Zahnfleischrückgang, Zahnschmerzen und Empfindlichkeit.',
        alText: 'التعرف على علامات قد تسقط أسنانك أمر حاسم للحفاظ على صحة الفم. الأسنان الطافية ، انحدار اللثة ، ألم الأسنان والحساسية.'
    },
    {
        img: procedureDayOneimg3,
        name: 'You need Nibh Euismod',
        glName: 'Sie brauchen Nibh Euismod',
        alName: 'تحتاج نيبه ايوسمود',
        text: 'Recognizing the signs your teeth may fall out is crucial for preserving dental health. Loose teeth, gum recession, toothache and sensitivity.',
        glText: 'Das Erkennen der Anzeichen dafür, dass Ihre Zähne ausfallen können, ist entscheidend für die Erhaltung der Zahngesundheit. Locker sitzende Zähne, Zahnfleischrückgang, Zahnschmerzen und Empfindlichkeit.',
        alText: 'التعرف على علامات قد تسقط أسنانك أمر حاسم للحفاظ على صحة الفم. الأسنان الطافية ، انحدار اللثة ، ألم الأسنان والحساسية.'
    },
];

const ProcedureDayOneQuestions = [
    {
        question: 'How to take care during Dental:',
        glQuestion: 'Wie man während der Zahnbehandlung aufpasst:',
        alQuestion: 'كيفية العناية خلال العلاج السني:',
        answer: "The customer is very important, the customer will be followed by the customer. That is Maecenas, but the pool of life. The customer is very happy. Going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of the text.",
        glAnswer: "Der Kunde ist sehr wichtig, der Kunde wird vom Kunden gefolgt. Das ist Maecenas, aber der Pool des Lebens. Der Kunde ist sehr glücklich. Wenn Sie einen Abschnitt von Lorem Ipsum verwenden, müssen Sie sicherstellen, dass sich nichts Peinliches im Text versteckt.",
        alAnswer: "العميل مهم جدًا ، سيتم متابعة العميل من قبل العميل. هذا هو مايسيناس ، ولكن بركة الحياة. العميل سعيد جدًا. سيتم استخدام مقطع من لوريم إيبسوم ، عليك التأكد من عدم وجود أي شيء محرج مخفي في منتصف النص."
    },
    {
        question: 'When to Visit your Doctor?',
        glQuestion: 'Wann den Arzt aufsuchen?',
        alQuestion: 'متى تزور طبيبك؟',
        answer: "Consectetur adipiscing elite. Maecenas id is thirsty lacus volutpat lobortis. Lorem ipsum hurt his heart. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn’t anything embarrassing hidden in the middle of text.",
        glAnswer: "Consectetur adipiscing elite. Maecenas id is thirsty lacus volutpat lobortis. Lorem ipsum hurt his heart. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn’t anything embarrassing hidden in the middle of text.",
        alAnswer: "العميل مهم جدًا ، سيتم متابعة العميل من قبل العميل. هذا هو مايسيناس ، ولكن بركة الحياة. العميل سعيد جدًا. سيتم استخدام مقطع من لوريم إيبسوم ، عليك التأكد من عدم وجود أي شيء محرج مخفي في منتصف النص."
    },
    {
        question: 'Dental Options:',
        glQuestion: 'Zahloptionen:',
        alQuestion: 'خيارات الأسنان:',
        answer: "The customer is very important, the customer will be followed by the customer. That is Maecenas, but the pool of life. The customer is very happy. Going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of the text.",
        glAnswer: "Der Kunde ist sehr wichtig, der Kunde wird vom Kunden gefolgt. Das ist Maecenas, aber der Pool des Lebens. Der Kunde ist sehr glücklich. Wenn Sie einen Abschnitt von Lorem Ipsum verwenden, müssen Sie sicherstellen, dass sich nichts Peinliches im Text versteckt.",
        alAnswer: "العميل مهم جدًا ، سيتم متابعة العميل من قبل العميل. هذا هو مايسيناس ، ولكن بركة الحياة. العميل سعيد جدًا. سيتم استخدام مقطع من لوريم إيبسوم ، عليك التأكد من عدم وجود أي شيء محرج مخفي في منتصف النص."
    }
];

const procedureDayTwoData = [
    {
        img: procedureDayTwoImg1,
        name: 'Nonummy Nibh Euismod',
        glName: 'Nonummy Nibh Euismod',
        alName: 'نونومي نيبه إيويزمود'
    },
    {
        img: procedureDayTwoImg2,
        name: 'Some kind of airline',
        glName: 'Irgendeine Art von Fluggesellschaft',
        alName: 'نوع ما من شركة طيران'
    },
];

const procedurePriceData = [
    {
        months: '3',
        price: 28,
        text: "But it's fun to be funny. Until the members of the great arrows.",
        glText: "Aber es macht Spaß, lustig zu sein. Bis die Mitglieder der großen Pfeile.",
        alText: "لكن من الممتع أن تكون مضحكًا. حتى أعضاء السهام العظيمة."
    },
    {
        months: '6',
        price: 38,
        text: "But it's fun to be funny. Until the members of the great arrows.",
        glText: "Aber es macht Spaß, lustig zu sein. Bis die Mitglieder der großen Pfeile.",
        alText: "لكن من الممتع أن تكون مضحكًا. حتى أعضاء السهام العظيمة."
    },
    {
        months: '9',
        price: 48,
        text: "But it's fun to be funny. Until the members of the great arrows.",
        glText: "Aber es macht Spaß, lustig zu sein. Bis die Mitglieder der großen Pfeile.",
        alText: "لكن من الممتع أن تكون مضحكًا. حتى أعضاء السهام العظيمة."
    },
];
const procedureBottomData = [
    {
        icon: <FaQuestion />,
        name: 'Dental Surgery',
        text: 'They are about to receive two troubles, blinded by desire, they do not provide for them, and they are similarly guilty of those who abandon their duties because of the softness of their mind, that is, the flight of toils and sorrows',
        glName: 'Zahnchirurgie',
        alName: 'جراحة الأسنان',
        glText: 'Sie stehen kurz davor, zwei Probleme zu erhalten, geblendet von Verlangen, sie kümmern sich nicht darum, und sie sind ebenso schuldig wie diejenigen, die ihre Pflichten wegen der Weichheit ihres Geistes aufgeben, das heißt, des Flugs von Mühen und Leiden.',
        alText: 'هم على وشك تلقي مشاكلين، أعمى بالرغبة، لا يقدمون لها، وهم متورطون بشكل مماثل مع الذين يتخلون عن واجباتهم بسبب ضعف عقلهم، وهو الهروب من الكد والأحزان.'
    },
    {
        icon: <FaFemale />,
        name: 'Dental Option',
        text: 'They are about to receive two troubles, blinded by desire, they do not provide for them, and they are similarly guilty of those who abandon their duties because of the softness of their mind, that is, the flight of toils and sorrows',
        glName: 'Zahloption',
        alName: 'خيارات الأسنان',
        glText: 'Sie stehen kurz davor, zwei Probleme zu erhalten, geblendet von Verlangen, sie kümmern sich nicht darum, und sie sind ebenso schuldig wie diejenigen, die ihre Pflichten wegen der Weichheit ihres Geistes aufgeben, das heißt, des Flugs von Mühen und Leiden.',
        alText: 'هم على وشك تلقي مشاكلين، أعمى بالرغبة، لا يقدمون لها، وهم متورطون بشكل مماثل مع الذين يتخلون عن واجباتهم بسبب ضعف عقلهم، وهو الهروب من الكد والأحزان.'
    },
];



const portfolioImgSrc = [
    ModernTitle1,
    ModernTitle2,
    ModernTitle3,
    ModernTitle4,
    ModernTitle5,
    ModernTitle6,
    ModernTitle7,
    ModernTitle8,
    ModernTitle9,
    ModernTitle10,
    ModernTitle11,
    ModernTitle12,
]
export {
    serviceData,
    menuItems,
    homeDentalProcedure,
    treatmentHistory,
    doctorsData,
    dentalSpecialities,
    locationData,
    dentistryData,
    serviceSliderImg,
    procedureData,
    aboutData,
    modernTitle,
    aboutFaqs,
    aboutPricingCardData,
    aboutSolutionData,
    aboutDentalCareData,
    initialShopData,
    procedureDentalList,
    procedureDayOneData,
    ProcedureDayOneQuestions,
    procedureDayTwoData,
    procedurePriceData,
    procedureBottomData,
    portfolioImgSrc
}